/**
 * Shared constants across all platforms (Native, Web, etc.)
 /** Waits for the app to finish booting (skeleton overlay disappears). */

/**
 * The identifier used for local data created when in Visitor Mode (unauthenticated).
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export const VISITOR_ID = "visitor";

/**
 * Standard HTTP Status Codes
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * The slug for the default "Inbox" list.
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export const INBOX_SLUG = "inbox";

/**
 * A stable reference for an empty array to prevent unnecessary re-renders in hooks.
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * Deep Linking Configuration
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export const APP_SCHEME = "bodega";
export const APP_DOMAIN = "app.bodega.com";
